import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA from 'react-ga4';

const REACT_APP_GA_MEASUREMENT_ID="G-BZ8HXQ5QQB";
if (REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(REACT_APP_GA_MEASUREMENT_ID);
}

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);


root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
